import { BaseDialog } from '@/components/BaseDialog'
import { useGetPatientItems } from '@/features/patients/hooks/usePatient'
import { useTranslation } from 'react-i18next'
import { useGetBed } from '../hooks/useBed'
import { BedDetailContent } from './BedDetailContent'

export function BedDetailDialog({
  open,
  onOpenChange,
  departmentId,
  bedId,
}: {
  open: boolean
  onOpenChange: (o: boolean) => void
  departmentId: string
  bedId: string
}) {
  const { t } = useTranslation()
  const { data: bed, isLoading: isLoadingBed } = useGetBed(departmentId, bedId)
  const { data: patientItems, isLoading: isLoadingPatientItems } = useGetPatientItems(bed?.patientId!, !!bed?.patientId)
  return (
    <BaseDialog open={open} onOpenChange={onOpenChange} contentTestId="bed-detail-dialog">
      {isLoadingBed ? (
        <div className="flex items-center justify-center py-8">
          <div className="text-sm text-muted-foreground">{t('common.loading')}</div>
        </div>
      ) : !bed ? (
        <h1 className="mt-4 text-lg font-semibold text-foreground">ไม่พบเตียง</h1>
      ) : (
        <BedDetailContent bed={bed} patientItems={patientItems}></BedDetailContent>
      )}
    </BaseDialog>
  )
}
